import { render, staticRenderFns } from "./setup_app_dialog.vue?vue&type=template&id=5bbe4e9f&scoped=true&"
import script from "./setup_app_dialog.vue?vue&type=script&lang=js&"
export * from "./setup_app_dialog.vue?vue&type=script&lang=js&"
import style0 from "./setup_app_dialog.vue?vue&type=style&index=0&id=5bbe4e9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbe4e9f",
  null
  
)

export default component.exports